<div
  class="position-absolute translate-middle-x bottom-7 start-50 col z-3"
  [class.d-none]="allowedDatasources.length === 0"
  data-cy="dropdown-warnings-menu"
>
  <div isDemoEnabled ngbDropdown placement="top" class="d-inline-block z-5">
    <button
      type="button"
      class="btn btn-outline-primary z-5 shadow-sm rounded-2 bg-dark cursor-pointer border hover-effect border-darkgray text-deactivated"
      id="dropdownBasic1"
      ngbDropdownToggle
      data-cy="dropdown-warnings-toggle"
    >
      {{ currentDatasource() }}
    </button>

    <div
      isDemoEnabled
      ngbDropdownMenu
      class="z-5 shadow-sm rounded-2 bg-dark cursor-pointer border border-darkgray hover-effect text-deactivated"
      aria-labelledby="dropdownBasic1"
      dropdownWarningsToggle
    >
      @for (datasource of allowedDatasources; track datasource) {
        <button
          ngbDropdownItem
          class="z-5 shadow-sm rounded-2 bg-dark hover cursor-pointer hover-effect text-deactivated"
          (click)="setCurrentDatasource(datasource)"
          data-cy="dropdown-warnings-item"
        >
          {{ datasource }}
        </button>
      }
    </div>
  </div>
</div>
